import { ensureMetaPixelLoaded, hasAnalyticsConsent } from "./tracking";

const getFbq = () => {
  if (typeof window === "undefined") return null;
  return typeof window.fbq === "function" ? window.fbq : null;
};

export const trackMetaPixel = (eventName, params) => {
  if (!hasAnalyticsConsent()) return;
  ensureMetaPixelLoaded();
  const fbq = getFbq();
  if (!fbq || !eventName) return;

  if (params && typeof params === "object") {
    fbq("track", String(eventName), params);
    return;
  }

  fbq("track", String(eventName));
};
